import "./DigitalWallet.css";
import digitalWallet from "../assets/images/digital-wallet.png";
import starIcon from "../assets/images/star-icon.png";

const DigitalWallet = () => {
  return (
    <section className="digital-wallet section">
      <div className="digital-wallet-container">
        <div className="digital-wallet-background">
          <div className="background-blur"></div>
          <div className="floating-elements">
            <div className="ellipse ellipse-1"></div>
            <div className="ellipse ellipse-2"></div>
            <div className="ellipse ellipse-3"></div>
            <div className="star star-13">★</div>
            <div className="star star-14">★</div>
          </div>
        </div>

        <div className="digital-wallet-content">
          <div className="content-text">
            <h2 className="section-title">
              Digital wallet that
              <br />
              <span className="highlight-text">handles it all</span>
            </h2>
            <p className="subtitle">
              Connect your crypto wallet and load up with $FLOW to unlock the
              full potential of the marketplace. With fast, low-cost, and secure
              transactions, purchasing exclusive items has never been easier.
              Join a vibrant network of collectors and creators, and experience
              seamless, real-time purchasing power—powered by $FLOW.
            </p>
            <div className="digital-wallet-stars">
              <img
                src={starIcon}
                alt=""
                className="star star-1"
                loading="lazy"
                aria-hidden="true"
              />
            </div>
          </div>

          <div className="content-image">
            <img
              src={digitalWallet}
              alt="Digital Wallet Interface"
              loading="lazy"
            />
            <img
              src={starIcon}
              alt=""
              className="floating-star"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalWallet;
